import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import CheckoutAPIClient from "../client/CheckoutAPIClient";
import ActionResultEvents from "../constants/events/ActionResultEvents";

class CheckoutActions {

    constructor() {
        this.checkoutApiClient = new CheckoutAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.CHECKOUT_VIEW_MOUNTED, this.handleCheckoutSessionRequired);
        EventPublisher.subscribe(UIInteractionEvents.CHECKOUT_PAY_CLICKED, this.handleStripePaymentAttempt);
    }

    handleCheckoutSessionRequired = (topic, data) => {
        this.checkoutApiClient.createCheckoutSession(data.id);
    };

    handleStripePaymentAttempt = (topic, data) => {
        data.stripe.confirmCardPayment(
            data.clientSecret,
            {
                payment_method: {
                    card: data.card
                }
            }
        ).then(
            (result) => {
                if (result.error) {
                    EventPublisher.publish(ActionResultEvents.CHECKOUT_PAYMENT_FAILED, {"message": result.error.message});
                } else {
                    this.checkoutApiClient.markReservationAsPaid(data.reservationRequestId);
                }
            }
        );
    }

}

export default new CheckoutActions();
